import { withCompInfo } from '@wix/editor-elements-integrations'
import { colorApi, getScaledFont } from '@wix/thunderbolt-becky-root'
import { SiteButtonCSSVars, SiteButtonDefinition } from './SiteButton'

import _ from 'lodash'

const aligns = {
	center: 'center',
	left: 'flex-start',
	right: 'flex-end',
} as const

export const css = withCompInfo<SiteButtonCSSVars, SiteButtonDefinition>()(
	// @ts-ignore - remove once siteFonts is added to CompInfo
	['styleProperties', 'compProps', 'compLayout', 'siteColors', 'siteFonts', 'skin', 'isMobileView'],
	// @ts-ignore - remove once siteFonts is added to CompInfo
	({ styleProperties, compProps, compLayout, siteColors, siteFonts, skin, isMobileView }) => {
		const brightnessParams =
			skin === 'ScotchTapeButton' ? {} : colorApi.getBrightnessCSSVars({ siteColors, styleProperties })

		const { align, margin } = compProps
		const labelMargin = align === 'left' || align === 'right' ? { [`--margin-${align}`]: `${margin}px` } : {}

		return _.pickBy(
			{
				...brightnessParams,
				...labelMargin,
				'--fnt': getScaledFont({ styleProperties, compLayout, isMobileView, siteFonts, compProps }, 'fnt'),
				'--label-align': aligns[align],
				'--label-text-align': align,
			},
			_.identity
		)
	}
)
